const defaultSuccessMessage = "Operação realizada com sucesso";
const defaultErrorMessage = "Ocorreu um erro ao executar a operação";

export const ptBrOverrides: Record<string, string> = {
  "buttons.delete": "Excluir",
  "buttons.cancel": "Cancelar",
  "buttons.edit": "Editar",
  "buttons.create": "Incluir",

  "notifications.success": defaultSuccessMessage,
  "notifications.error": defaultErrorMessage,
  "notifications.createSuccess": "Registro criado com sucesso",
  "notifications.createError":
    "Não foi possível criar o registro. Tente novamente.",
  "notifications.editSuccess": "Alterações salvas com sucesso",
  "notifications.editError":
    "Não foi possível atualizar o registro. Tente novamente.",
  "notifications.deleteSuccess": "Registro excluído com sucesso",
  "notifications.deleteError":
    "Não foi possível excluir o registro. Tente novamente.",
  "notifications.fetchError":
    "Não foi possível carregar os dados. Atualize a página e tente novamente.",
  "notifications.validationError":
    "Verifique os dados informados e tente novamente.",
  "notifications.networkError":
    "Falha de comunicação com o servidor. Verifique sua conexão.",
  "notifications.permissionError":
    "Você não tem permissão para executar esta ação.",

  "featureFlags.title": "Controle de Funcionalidades",
  "featureFlags.subtitle":
    "Feature flags por ambiente em tempo real, sem necessidade de deploy.",
  "featureFlags.createTitle": "Incluir",
  "featureFlags.filterTitle": "Filtrar",
  "featureFlags.environment": "Ambiente atual",
  "featureFlags.successTitle": "Sucesso",
  "featureFlags.successMessage": "Solicitação realizada com sucesso!",
};
